module.exports = __webpack_public_path__ + "img/chad-harrington.4bcd73fc.jpg";